const TrackOrderIcon = (props) => {
  return (
    <svg viewBox='0 0 24 24'>
      <path
        d='M20 7H4m6 4h10M4 11h4m6 4h6M4 15h4'
        stroke='currentColor'
        strokeWidth='1.6'
        strokeLinecap='round'
        {...props}
      />
    </svg>
  );
};

export default TrackOrderIcon;
